import React from 'react';

export const RocketShip: React.FC = () => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 600;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: isMobile ? '45%' : '70%',
          left: '-200px',
          width: '60px',
          height: '60px',
          animation: 'rocket-fly 15s linear infinite',
          animationDelay: '5s',
        }}
      >
        {/* Rocket trail (cartoon flame shape) */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '32px',
            height: '16px',
            transform:
              'translate(-50%, -50%) rotate(219deg) scaleX(1.3) skewX(-18deg) translateY(-3px) translateX(28px)',
            zIndex: 0,
            pointerEvents: 'none',
          }}
        >
          {/* Main cartoon flame (yellow to orange to red, rounded, skewed) */}
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
              borderRadius: '60% 100% 80% 100% / 100% 100% 80% 100%',
              background:
                'linear-gradient(90deg, #fffbe0 0%, #ffe066 30%, #ffb347 60%, #ff6b35 100%)',
              filter: 'blur(0.5px)',
              opacity: 0.85,
              boxShadow: '0 0 12px 2px #ffb347',
              animation: 'rocket-flame-flicker 1.2s infinite alternate',
            }}
          />
          {/* Cartoon core (smaller, sharp, yellow/white) */}
          <div
            style={{
              position: 'absolute',
              left: '30%',
              top: '35%',
              width: '32%',
              height: '40%',
              borderRadius: '60% 100% 80% 100% / 100% 100% 80% 100%',
              background: 'linear-gradient(90deg, #fffbe0 0%, #ffe066 100%)',
              filter: 'blur(0.5px)',
              opacity: 0.95,
            }}
          />
        </div>

        {/* Rocket SVG */}
        <svg
          width="60"
          height="60"
          viewBox="0 0 1554 1554"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            filter: 'drop-shadow(0 0 6px rgba(255, 107, 53, 0.2))',
            transform: 'rotate(80deg)',
            zIndex: 1,
          }}
        >
          <path
            d="M545.047 1215.66C529.73 1304.61 466.922 1377.35 382.318 1404.13C297.182 1431.08 192.397 1414.85 110.8 1442.91C138.874 1361.33 122.637 1256.54 149.589 1171.4C176.369 1086.8 249.114 1023.99 338.051 1008.67L367.329 986.795L571.004 1190.47L545.047 1215.66Z"
            fill="#F4CC21"
          />
          <path
            d="M467.126 1086.6L110.8 1442.92C138.866 1361.32 122.629 1256.54 149.589 1171.4C176.369 1086.8 249.111 1023.98 338.047 1008.67L367.329 986.797L467.126 1086.6Z"
            fill="#E2A817"
          />
          <path
            d="M627.198 1195.51L569.682 1222.87C562.544 1226.26 554.576 1225.19 549.537 1220.15L472.324 1142.94L410.482 1081.1L333.569 1004.18C328.53 999.146 327.458 991.178 330.848 984.04L358.209 926.524L383.762 900.971L652.751 1169.96L627.198 1195.51Z"
            fill="#2C3235"
          />
          <path
            d="M518.255 1035.47L441.548 1112.17L333.57 1004.2C328.526 999.152 327.462 991.179 330.848 984.035L358.209 926.522L383.76 900.971L518.255 1035.47Z"
            fill="#1B1F21"
          />
          <path
            d="M525.706 712.289C423.568 610.151 242.546 619.242 8.72427 853.064L8.68725 853.027C-2.89575 864.61 -2.89575 883.389 8.68725 894.971C14.8503 901.134 26.9282 904.419 40.3932 900.337C283.445 826.666 370.216 875.657 370.216 875.657L529.645 716.228L525.706 712.289Z"
            fill="#5D5F61"
          />
          <path
            d="M841.433 1028.02C943.571 1130.15 934.48 1311.18 700.658 1545L700.695 1545.03C689.112 1556.62 670.333 1556.62 658.751 1545.03C652.588 1538.87 649.303 1526.79 653.385 1513.33C727.056 1270.28 678.065 1183.51 678.065 1183.51L837.494 1024.08L841.433 1028.02Z"
            fill="#787D82"
          />
          <path
            d="M1537.86 292.316C1508.86 455.124 1431.39 664.713 1238.54 857.564C1072.04 1024.06 805.527 1160.81 645.585 1201.76C639.526 1203.31 633.546 1201.85 629.56 1197.86L355.862 924.163C351.876 920.177 350.41 914.197 351.958 908.138C392.917 748.196 529.665 481.682 696.159 315.188C889.01 122.337 1098.6 44.8617 1261.41 15.8677C1261.41 15.8677 1321.19 11.3117 1431.8 121.925C1543.25 233.372 1537.86 292.316 1537.86 292.316Z"
            fill="#DDE7ED"
          />
          <path
            d="M1431.8 121.921L492.704 1061.02L355.859 924.173C351.866 920.179 350.415 914.196 351.962 908.143C392.92 748.207 529.669 481.674 696.155 315.188C889.007 122.336 1098.59 44.8546 1261.4 15.8636C1261.4 15.8636 1321.18 11.3026 1431.8 121.921Z"
            fill="#B6CBD6"
          />
          <path
            d="M667.627 968.954C508.558 1128.02 347 1265.17 317.777 1235.95C287.442 1205.61 425.699 1045.16 584.768 886.095C607.649 863.214 644.746 863.214 667.627 886.095C690.508 908.976 690.508 946.073 667.627 968.954Z"
            fill="#787D82"
          />
          <path
            d="M667.62 886.102L317.775 1235.95C287.443 1205.61 425.698 1045.17 584.764 886.102C607.647 863.219 644.736 863.219 667.62 886.102Z"
            fill="#5D5F61"
          />
          <path
            d="M1032.68 774.363C1172.58 774.363 1286 660.947 1286 521.043C1286 381.138 1172.58 267.723 1032.68 267.723C892.775 267.723 779.359 381.138 779.359 521.043C779.359 660.947 892.775 774.363 1032.68 774.363Z"
            fill="white"
          />
          <path
            d="M1211.81 341.913L853.549 700.173C754.622 601.246 754.622 440.84 853.549 341.913C952.476 242.986 1112.88 242.986 1211.81 341.913Z"
            fill="#E4EDF2"
          />
          <path
            d="M1174.87 663.233C1096.33 741.77 969.008 741.77 890.471 663.233C874.689 647.451 862.07 629.678 852.633 610.75C846.164 597.776 841.188 584.233 837.722 570.388C833.368 553.166 831.324 535.482 831.626 517.834C832.159 482.609 841.934 447.525 860.897 416.477C869.037 403.076 878.918 390.422 890.488 378.852C969.025 300.315 1096.35 300.315 1174.87 378.834C1186.46 390.422 1196.34 403.076 1204.48 416.476C1223.44 447.525 1233.2 482.626 1233.75 517.833C1234.02 535.481 1232.01 553.165 1227.65 570.387C1224.17 584.214 1219.18 597.739 1212.72 610.731C1203.27 629.678 1190.67 647.433 1174.87 663.233Z"
            fill="#534DBA"
          />
          <path
            d="M890.471 663.233C874.689 647.451 862.07 629.678 852.633 610.75C846.164 597.776 841.188 584.233 837.722 570.388C833.368 553.166 831.324 535.482 831.626 517.834C832.159 482.609 841.934 447.525 860.897 416.477C869.037 403.076 878.918 390.422 890.488 378.852C969.025 300.315 1096.35 300.315 1174.87 378.834L890.471 663.233Z"
            fill="#443EB1"
          />
          <path
            d="M1537.86 292.315C1537.86 292.315 1515.36 244.671 1412.2 141.507C1309.05 38.3595 1261.41 15.8675 1261.41 15.8675C1373.22 -4.05452 1462.98 -1.12853 1510.15 2.99348C1532.37 4.95948 1548.76 21.3495 1550.71 43.5605C1554.84 90.7275 1557.78 180.506 1537.86 292.315Z"
            fill="#787D82"
          />
          <path
            d="M1538.04 15.6836L1412.21 141.516L1412.19 141.502C1309.05 38.3596 1261.4 15.8626 1261.4 15.8626C1373.21 -4.05038 1462.98 -1.12039 1510.15 2.99761C1521.26 3.99261 1530.92 8.56662 1538.04 15.6836Z"
            fill="#5D5F61"
          />
        </svg>

        {/* Shock collar / transonic cloud at the rocket nose */}
        <div
          style={{
            position: 'absolute',
            top: '70%',
            left: '85%', // near the tip of the rocket
            width: '28px',
            height: '28px',
            transform: 'translate(-50%, -50%) scaleX(1.4) skewX(-12deg)',
            pointerEvents: 'none',
            zIndex: 2,
            animation: 'shock-collar-pulse 3s infinite cubic-bezier(.4,0,.2,1)',
          }}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '60% 100% 60% 100% / 100% 100% 80% 100%',
              background:
                'radial-gradient(ellipse 60% 45% at 65% 50%, rgba(220,230,255,0.22) 0%, rgba(200,220,255,0.10) 80%, rgba(200,220,255,0.0) 100%)',
              filter: 'blur(2px)',
            }}
          />
        </div>
      </div>

      <style>
        {`
          @keyframes rocket-fly {
            0% {
              transform: translateX(-200px) translateY(0px) rotate(-45deg);
              opacity: 0;
            }
            5% {
              opacity: 1;
            }
            95% {
              opacity: 1;
            }
            100% {
              transform: translateX(calc(100vw + 200px)) translateY(-400px) rotate(-45deg);
              opacity: 0;
            }
          }
          @keyframes rocket-flame-flicker {
            0% {
              opacity: 0.7;
              filter: blur(1.5px);
            }
            50% {
              opacity: 1;
              filter: blur(3.5px);
            }
            100% {
              opacity: 0.85;
              filter: blur(2.5px);
            }
          }
          @keyframes shock-collar-pulse {
            0% {
              opacity: 0.13;
              transform: scale(0.95);
            }
            40% {
              opacity: 0.18;
              transform: scale(1.08);
            }
            100% {
              opacity: 0.10;
              transform: scale(1.15);
            }
          }
        `}
      </style>
    </div>
  );
};
